import { render, staticRenderFns } from "./TabTechnical.vue?vue&type=template&id=ffa65254&"
import script from "./TabTechnical.vue?vue&type=script&lang=js&"
export * from "./TabTechnical.vue?vue&type=script&lang=js&"
import style0 from "./TabTechnical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports